<template>
  <div class="footer">
    <div class="g-container">
      <div class="logos">
        <img src="../../assets/footer1.png" alt="">
        <img src="../../assets/footer2.png" alt="">
        <img src="../../assets/footer3.png" alt="">
        <img src="../../assets/footer4.png" alt="">
      </div>
    </div>
    <div class="box">
      <div class="g-container container">
        <div class="g-font-mid title">
          <div>{{ $t('footer.title1') }}</div>
          <div>{{ $t('footer.title2') }}</div>
        </div>
        <a
          class="g-link-clear btn btn--contact"
          href="mailto:sales@railone.io"
        >
          {{ $t('footer.contact') }}
        </a>
        <a
          class="g-link-clear btn btn--login"
          href="https://customer.railone.io/#/register"
        >
          {{ $t('footer.login') }}
        </a>
      </div>
      <div class="box__terms">
        <div class="g-container">
          <span class="right">© 2020 Railone. All rights reserved.</span>
          <LinkBox class="terms__term first" key="a">
            <router-link class="g-link-clear" tag="a" to="/terms">
              {{ $t('footer.terms') }}
            </router-link>
          </LinkBox>
          <LinkBox class="terms__term" key="b">
            <router-link class="g-link-clear" tag="a" to="/privacy">
              {{ $t('footer.privacy') }}
            </router-link>
          </LinkBox>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import LinkBox from '@/components/LinkBox.vue';

export default {
  name: 'Footer',
  components: { LinkBox },
};
</script>

<style lang="scss" scoped>
  .footer {
    background: rgba(242, 242, 242, 1);
  }

  .logos {
    padding: 40px 80px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-row-gap: 30px;
    justify-items: center;
    @media (max-width: 750px) {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  .box {
    padding-top: 100px;
    background: rgba(19, 23, 43, 1);
    border-radius: 200px 0 0 0;
  }

  .container {
    @media (max-width: 1440px) {
      max-width: 760px;
    }
  }

  .title {
    color: var(--color-base-light);
    font-size: 40px;
    line-height: 60px;
  }

  .btn {
    box-sizing: border-box;
    display: inline-block;
    margin-top: 80px;
    padding: 0 40px;
    height: 60px;
    line-height: 58px;
    text-align: center;
    border-radius: 30px;
    cursor: pointer;
    color: var(--color-base-light);
    font-size: 18px;
    opacity: .8;
    transition: opacity .3s;
    &:hover {
      opacity: 1;
    }
  }

  .btn--contact {
    margin-right: 60px;
    border: 1px solid rgba(1, 210, 197, 1);
    background: rgba(1, 210, 197, 1);
  }

  .btn--login {
    border: 1px solid rgba(1, 210, 197, 1);
    background: transparent;
  }

  .terms__term {
    color: var(--color-content-light);
    transition: color .3s;
    line-height: 16px;
    /deep/ .link-box__dec {
      background: var(--color-content-light);
    }

    &:hover {
      color: var(--color-base-light);
    }

    &.first {
      margin-right: 20px;
    }
  }

  .right {
    float: left;
    color: var(--color-tip-light);
  }

  .box__terms {
    margin-top: 160px;
    text-align: right;
    line-height: 80px;
    background: rgba(23, 27, 46, 1);
  }

</style>
